export interface Buyer {
  name: string
  city: string
  country: string
  flag: string
}

export const buyers: Buyer[] = [
  { name: 'James T.', city: 'Manchester', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Ryan M.', city: 'Calgary', country: 'Canada', flag: '🇨🇦' },
  { name: 'Kevin B.', city: 'Phoenix, AZ', country: 'United States', flag: '🇺🇸' },
  { name: 'Liam C.', city: 'Brisbane', country: 'Australia', flag: '🇦🇺' },
  { name: 'Sarah W.', city: 'Birmingham', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Scott P.', city: 'Toronto', country: 'Canada', flag: '🇨🇦' },
  { name: 'Mike R.', city: 'Dallas, TX', country: 'United States', flag: '🇺🇸' },
  { name: 'Jordan H.', city: 'Perth', country: 'Australia', flag: '🇦🇺' },
  { name: 'Craig D.', city: 'Glasgow', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Tyler S.', city: 'Vancouver', country: 'Canada', flag: '🇨🇦' },
  { name: 'Brandon L.', city: 'Denver, CO', country: 'United States', flag: '🇺🇸' },
  { name: 'Nathan K.', city: 'Melbourne', country: 'Australia', flag: '🇦🇺' },
]
